
define(
	'Tavano.FirstContentPage.FirstContentPage'
,   [
		
	]
,   function (
		
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{

			try{

				var layout = container.getComponent('Layout');
			
				if(layout)
				{
					layout.on("afterShowContent",function(){
						jQuery("#pre-loading").hide();
					})
				}
				}catch(e){
					console.log(e)
				}
			}
	};
});
